import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CategoriesMenuComponent} from './categories-menu.component';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {CategoryEntryComponent} from './category-entry/category-entry.component';
import {CategoriesModalComponent} from './categories-modal/categories-modal.component';
import {CategorySubEntriesComponent} from './category-sub-entries/category-sub-entries.component';
import {ListGroupModule} from 'ng-design-system';


@NgModule({
  declarations: [
    CategoriesMenuComponent,
    CategoriesModalComponent,
    CategoryEntryComponent,
    CategorySubEntriesComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CategoriesMenuComponent: {
          component: CategoriesModalComponent
        }
      }
    }),
    ListGroupModule
  ]
})
export class CategoriesMenuModule {
}
